import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SectionFields,
  Value,
  Row,
  ValueNote,
  Title,
} from '../details-sidebar.styles';
import DetailsPanel from './details-panel.component';
import Tip from '../../../../common/toasts/tip.component';
import { ReactComponent as PromocodeIcon } from '../../../../assets/promocode-tag.svg';

interface Props {
  title: React.ReactNode;
  summary?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  items?: {
    name: string;
    value: React.ReactNode;
    valueNote?: React.ReactNode;
    isFinal?: boolean;
  }[];
  promocode?: React.ReactNode;
  justifySpaceBetween?: boolean;
}

const NameValueSection = ({
  title,
  summary,
  footer,
  children,
  items,
  promocode,
  justifySpaceBetween,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DetailsPanel
      title={title}
      summary={summary}
      footer={footer}>
      <SectionFields>
        {items?.length ? (
          items.map(({ name, value, valueNote, isFinal }) => (
            <Row
              $justifySpaceBetween={justifySpaceBetween}
              $isFinal={isFinal}
              key={name}>
              <Title>{name}</Title>
              <Value>
                {value}
                {valueNote && <ValueNote>{valueNote}</ValueNote>}
              </Value>
            </Row>
          ))
        ) : (
          <Value>{t('no_info')}</Value>
        )}
        {promocode && (
          <Tip
            appearance='success'
            description={promocode}
            icon={<PromocodeIcon />}
          />
        )}
      </SectionFields>
      {children}
    </DetailsPanel>
  );
};

export default NameValueSection;
